import { put } from 'redux-saga/effects';
import { fetchCollectionApi } from 'common/api';
import { addNewVideosInStore } from 'pages/home.page/video-carousel/actions';
import { errorHandleAction } from 'components/error-handle/actions';
import { fetchSortedVideosApi } from 'common/api/videos';

const sortingKeys = {
  newest: 'displayDate',
  mostPlayed: 'plays',
  topRated: 'rating',
};

/**
 * @param {object} action
 */
export function* requestNewVideosEffect(action) {
  try {
    const payload = action.payload;
    const pageNum = payload.pageNum + 1;
    let response;
    if (isNaN(payload.channelId)) {
      response = yield fetchSortedVideosApi(
        pageNum,
        payload.perPage,
        // default to "displayDate" if requested sorting isn't implemented
        sortingKeys[payload.channelId] || 'displayDate',
        'desc'
      );
    } else {
      response = yield fetchCollectionApi({
        channelId: payload.channelId,
        pageNum: pageNum,
        perPage: payload.perPage,
        featuredFirst: false,
      });
    }

    yield put(addNewVideosInStore(payload.channelId, response.videos));
  } catch (error) {
    yield put(errorHandleAction(error, error.status));
  }
}
